export const CustomMultilineOption = (props: any) => {
  const { data, isSelected, isFocused, innerRef, innerProps } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        padding: "10px 14px",
        // borderBottom: "1px solid #e8e8e8",
        backgroundColor: isSelected ? "#000" : isFocused ? "#000" : "#fff",
        color: isSelected ? "#fff" : isFocused ? "#fff" : "#000",
        cursor: "pointer",
        lineHeight: "1.6",
      }}
    >
      <div style={{ fontSize: "12px" }}>
        <span>Package Code – </span>
        <span>{data.code}</span>
      </div>
      <div style={{ fontSize: "12px" }}>
        <span>Package Name – </span>
        {data.name}
      </div>
      <div
        style={{
          fontSize: "12px",
          marginTop: "2px",
          whiteSpace: "normal",
          wordBreak: "break-word",
        }}
      >
        <span>Package Scope – </span>
        {data.scope}
      </div>
    </div>
  );
};

export const CustomPackageSingleValue = ({ data }: any) => (
  <span style={{ fontSize: "12px" }}>
    <strong>Package {data.code}</strong> — {data.name}
  </span>
);

export const packageSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    minHeight: "40px",
    height: "40px",
    // borderColor: state.isFocused ? "#dee2e6" : "#dee2e6",
    boxShadow: "none", // ← removes blue ring
    borderRadius: "0.375rem",
    fontSize: "13px",
    "&:hover": { borderColor: "#dee2e6" }, // no color change on hover
  }),
  valueContainer: (base: any) => ({
    ...base,
    height: "31px",
    padding: "0 8px",
    display: "flex",
    alignItems: "center", // vertically center the text
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    height: "31px",
  }),
  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  singleValue: (base: any) => ({
    ...base,
    margin: 0,
  }),
  placeholder: (base: any) => ({
    ...base,
    margin: 0,
    color: "#aaa",
  }),
  menu: (base: any) => ({
    ...base,
    zIndex: 9999,
    border: "1px solid #dee2e6",
    borderRadius: "0.375rem",
    boxShadow: "0 0.5rem 1rem rgba(0,0,0,0.1)",
  }),
  menuList: (base: any) => ({ ...base, padding: 0 }),
  option: () => ({}),
};
